import { I_Env, I_Options } from './interface';
import { defaultTypes, templates, dcbmservices, lists } from './configs';

export const environment: I_Env & I_Options = {
  production: true,
  application_instance: '6343db2ab5b7b28db15c3d12',

  ssoIssuer: 'https://api.justplug.fr',
  ssoUrl: 'https://api.justplug.fr/api-dcbm-admin/.well-known/openid-configuration',
  ssoclientId: 'dcbm',

  configurationUrl: 'https://api.justplug.fr/licencesService/',

  end_client: '633c0bd0b7e317df27ecbb43',
  scope: 'openid profile email phone',

  data: {
    api: 'https://api-dcbm-admin.justplug.io/',
    appApi: 'https://api-dcbm-client.justplug.io/',
    uploadapi: 'https://api-dcbm-client.justplug.io/',
    downloadApi: 'https://api-dcbm-admin.justplug.io/',
    avatarAdminUrl: 'https://api-dcbm-admin.justplug.io/',
    avatarUrl: 'https://api-dcbm-admin.justplug.io/fileService/',
    authServiceUrl: 'https://api-dcbm-admin.justplug.io/authentication/',

    templates: templates,
    defaultTypes: defaultTypes,
    dcbmservices: dcbmservices,
    lists: lists
  }
};
